
        import '/home/builduser/work/575538235ca6a4de/santa-editor/packages/advancedStylePanel/templates/ScrollResetButton/scrollResetButton.scss.css.virtualfile';
        module.exports = {"scrollBtnContainer":"_scrollBtnContainer_afmla_1"};